<template>
  <div
    v-if="files && files.length"
    class="file-list"
  >
    <div
      v-for="file in files"
      :key="file.id"
      class="file py-1 px-2 mb-1 d-flex justify-content-between bg-light"
    >
      <a
        class="file-name"
        href="#"
        target="_blank"
        @click.prevent="downloadFile(file)"
      >
        {{ file.name }}
      </a>
      <a
        v-if="deletable"
        :title="$t('delete')"
        class="file-delete text-danger"
        href="#"
        @click.prevent="deleteFile(file)"
      >
        <fa
          icon="times"
          fixed-width
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileList',

  props: {
    files: { type: Array, default: null },
    deletable: { type: Boolean, default: false }
  },

  methods: {
    async downloadFile (file) {
      if (!file.download_url) {
        return
      }
      const { data } = await this.$axios({
        url: file.download_url,
        method: 'get',
        responseType: 'blob'
      })
      const blob = new Blob([data], { type: file.type })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = file.name
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        document.body.removeChild(link)
      }, 100)
    },
    async deleteFile (file) {
      if (!file.delete_url) {
        return
      }
      const i = this.files.indexOf(file)
      await this.$axios.delete(file.delete_url)
      this.files.splice(i, 1)
    }
  }
}
</script>

<style>
  .file-name {
    word-break: break-word;
  }
</style>
